/** The data-URI CSV download button the Plans tab and revenue chart use. */
const CsvExportLink = ({ csv, filename, t }) =>
  csv ? (
    // biome-ignore lint/a11y/useSemanticElements: anchor needed for file download
    <a
      role="button"
      target="_blank"
      href={`data:attachment/csv,${encodeURIComponent(csv)}`}
      download={filename}
      data-button-type="primary"
    >
      {t("membershipList.exportCsv")}
    </a>
  ) : null;

export default CsvExportLink;
